var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeverages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7499 2.33003C19.6553 2.22518 19.5395 2.14156 19.4102 2.08468C19.281 2.02781 19.1411 1.99895 18.9999 2.00003H4.99989C4.85867 1.99895 4.71881 2.02781 4.58954 2.08468C4.46027 2.14156 4.34451 2.22518 4.24989 2.33003C4.15553 2.43503 4.08446 2.55882 4.04137 2.69326C3.99828 2.8277 3.98415 2.96974 3.99989 3.11003L5.79989 19.33C5.88146 20.0672 6.2332 20.748 6.78721 21.2411C7.34123 21.7341 8.05825 22.0045 8.79989 22H15.2199C15.9615 22.0045 16.6786 21.7341 17.2326 21.2411C17.7866 20.748 18.1383 20.0672 18.2199 19.33L19.9999 3.11003C20.0156 2.96974 20.0015 2.8277 19.9584 2.69326C19.9153 2.55882 19.8443 2.43503 19.7499 2.33003ZM16.1999 19.11C16.1727 19.3557 16.0555 19.5827 15.8708 19.747C15.6861 19.9114 15.4471 20.0015 15.1999 20H8.78989C8.54268 20.0015 8.30367 19.9114 8.119 19.747C7.93433 19.5827 7.81708 19.3557 7.78989 19.11L6.77989 10H17.2199L16.1999 19.11ZM17.4399 8.00003H6.55989L6.11989 4.00003H17.8799L17.4399 8.00003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverages);
export default __webpack_public_path__ + "static/media/beverages.76f05ed517b0fa19e4904a303af699cf.svg";
export { ForwardRef as ReactComponent };